import { Type } from "@sinclair/typebox";
import { IdSchema, Sha256Schema, TimestampSchema } from "./shared.js";
import { ActionRequestSchema, ActionGrantSchema } from "./action.js";
/** 生命周期描述执行归属，不授予工具调用权限。 */
export const LifecycleContractSchema = Type.Union([
    Type.Object({ kind: Type.Literal("local") }, { additionalProperties: false }),
    Type.Object({ kind: Type.Literal("remote_observer"), resourceIdField: IdSchema }, { additionalProperties: false }),
    Type.Object({
        kind: Type.Literal("remote_job"),
        resourceIdField: IdSchema,
        statusFunction: IdSchema,
        cancelFunction: IdSchema,
        recovery: Type.Literal("manual"),
        evidence: Type.Literal("service_terminal"),
    }, { additionalProperties: false }),
]);
export const TerminationResourceSchema = Type.Object({
    grantId: IdSchema,
    resourceId: Type.Union([IdSchema, Type.Null()]),
    state: Type.Union(["creating", "active", "unknown", "terminal"].map((value) => Type.Literal(value))),
}, { additionalProperties: false });
export const TerminationSchema = Type.Object({
    terminationId: IdSchema,
    identityId: IdSchema,
    sessionId: IdSchema,
    turnId: Type.Union([IdSchema, Type.Null()]),
    generation: Type.Integer({ minimum: 0 }),
    targetDigest: Sha256Schema,
    state: Type.Union(["requested", "stopping", "verifying", "needs_attention", "completed"].map((value) => Type.Literal(value))),
    pending: Type.Integer({ minimum: 0 }),
    unknown: Type.Integer({ minimum: 0 }),
    attempts: Type.Integer({ minimum: 0 }),
    lastError: Type.Union([Type.String({ maxLength: 512 }), Type.Null()]),
    steps: Type.Array(Type.Object({
        stage: Type.Union(["local_stop", "remote_stop", "remote_status", "local_absent"].map((value) => Type.Literal(value))),
        state: Type.Union([Type.Literal("succeeded"), Type.Literal("failed")]),
        errorCode: Type.Union([
            Type.Null(),
            ...["binding_mismatch", "forbidden", "invalid_state", "unavailable"].map((value) => Type.Literal(value)),
        ]),
        detailCode: Type.Union([
            Type.Null(),
            Type.String({ pattern: "^[a-z][a-z0-9_]{0,127}$" }),
        ]),
        requestId: Type.Union([IdSchema, Type.Null()]),
        checkedAt: TimestampSchema,
    }, { additionalProperties: false }), { maxItems: 4 }),
    resources: Type.Array(TerminationResourceSchema),
    updatedAt: TimestampSchema,
}, { additionalProperties: false });
export const TerminationControlSchema = Type.Object({
    terminationId: IdSchema,
    sessionId: IdSchema,
    generation: Type.Integer({ minimum: 0 }),
    targetDigest: Sha256Schema,
    grantIds: Type.Array(IdSchema, { maxItems: 10000, uniqueItems: true }),
    operation: Type.Union(["stop", "status", "resolve"].map((value) => Type.Literal(value))),
    resolution: Type.Union([
        Type.Null(),
        Type.Object({
            grantId: IdSchema,
            resourceId: Type.Union([IdSchema, Type.Null()]),
            evidenceDigest: Sha256Schema,
            operatorId: IdSchema,
        }, { additionalProperties: false }),
    ]),
}, { additionalProperties: false });
export const TerminationRequestSchema = Type.Object({
    control: TerminationControlSchema,
    request: ActionRequestSchema,
    grant: ActionGrantSchema,
}, { additionalProperties: false });
export const TerminationResultSchema = Type.Object({
    terminationId: IdSchema,
    sessionId: IdSchema,
    generation: Type.Integer({ minimum: 0 }),
    targetDigest: Sha256Schema,
    pending: Type.Integer({ minimum: 0 }),
    unknown: Type.Integer({ minimum: 0 }),
    resources: Type.Array(TerminationResourceSchema),
    confirmedAt: TimestampSchema,
}, { additionalProperties: false });
//# sourceMappingURL=lifecycle.js.map